import { diContainer, serviceNames } from './service-setup/diContainer';

import { setupServiceInfo } from '@estee/elc-universal-utils';

diContainer.get(serviceNames.accountService).register();

setupServiceInfo(__serviceInfo__);
